// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-logos-wrapper[data-v-aa6f934c]{margin:0 auto;width:100%}.payment-logos[data-v-aa6f934c]{display:flex;flex-wrap:wrap;gap:1.4rem;justify-content:center;margin:0 auto}.payment-logos img[data-v-aa6f934c]{height:var(--mobile-icon-height);width:auto}@media screen and (min-width:1024px){.desktop-icon-height[data-v-aa6f934c]{height:var(--desktop-icon-height)!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
